import { useState, useEffect, useCallback, useRef } from "react";
import AuthService from "services/auth.service";

/**
 * Fetches and polls user balance data:
 * - availableBalance, transactionRefundableFee, pendingPayment
 * - Account status (polled every 60s)
 */
export default function useBalanceData() {
  const currentUser = AuthService.getCurrentUser();
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const fetchStatus = useCallback(() => {
    if (!currentUser?.id) return;
    const controller = new AbortController();
    abortRef.current = controller;

    AuthService.getStatus(currentUser.id)
      .then((response) => {
        if (!controller.signal.aborted) {
          setStatus(response.data.status);
          setLoading(false);
        }
      })
      .catch((e) => {
        if (!controller.signal.aborted) {
          setError(e);
          setLoading(false);
        }
      });
  }, [currentUser?.id]);

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 60000);

    return () => {
      clearInterval(interval);
      if (abortRef.current) {
        abortRef.current.abort();
      }
    };
  }, [fetchStatus]);

  const availableBalance = currentUser?.availableBalance ?? "0";
  const refundableBalance = currentUser?.transactionRefundableFee ?? "0";
  const pendingPayment = currentUser?.pendingPayment ?? "0";
  const tcc = currentUser?.tcc ?? "";

  return {
    availableBalance,
    refundableBalance,
    pendingPayment,
    tcc,
    status,
    loading,
    error,
    currentUser,
    refresh: fetchStatus,
  };
}